export type ProjectsListKeyParams = {
  q?: string;
  sort?: string;
  progressFrom?: number;
  progressTo?: number;
  statusKeys?: string[];
  priorityIds?: string[];
  responsibleWorkerIds?: string[];
  clients?: string[];
  startDateFrom?: string;
  startDateTo?: string;
  dueDateFrom?: string;
  dueDateTo?: string;
  active?: boolean;
};

export const projectsKeys = {
  all: ["projects"] as const,
  lists: () => [...projectsKeys.all, "list"] as const,
  list: (params?: ProjectsListKeyParams) => [...projectsKeys.lists(), params] as const,
  detail: (id: string) => [...projectsKeys.all, "detail", id] as const,
  nextCode: () => [...projectsKeys.all, "nextCode"] as const,
  quotaCount: () => [...projectsKeys.lists(), "quotaCount"] as const,
  filterOptions: (params: { type: string; q?: string }) =>
    [...projectsKeys.all, "filterOptions", params] as const,
  filterOptionIds: (params: { type: string; ids: string[] }) =>
    [...projectsKeys.all, "filterOptionIds", params] as const,
};
